import { format, parseISO } from 'date-fns'

const getOrdinal = (day) => {
  if (day > 3 && day < 21) return 'th'
  switch (day % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export const formatDate = (isoDate) => {
  const date = parseISO(isoDate)
  const day = format(date, 'd')
  const month = format(date, 'MMMM')
  const year = format(date, 'yyyy')

  const ordinal = getOrdinal(day)

  return `${month} ${day}${ordinal} ${year}`
}

export const formatArticleDate = (isoDate) => {
  const date = parseISO(isoDate)
  const day = format(date, 'd')
  const month = format(date, 'MMM')
  const year = format(date, 'yyyy')

  return ` ${day} ${month} ${year}`
}

export const formatReviewDate = (isoDate) => {
  const date = parseISO(isoDate)
  const day = format(date, 'd')
  const month = format(date, 'MMMM')
  const year = format(date, 'yyyy')

  const ordinal = getOrdinal(day)

  return ` ${day}${ordinal} ${month} ${year}`
}
